import { FC, ReactNode } from 'react';
import { Box, SxProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

const buttonStyles: SxProps = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  color: 'white',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  borderRadius: '20px',
  padding: '8px',
  cursor: 'pointer',
  overflow: 'hidden',
  width: '40px',
  transition: 'all 0.5s ease-in-out',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    width: 'auto',
    paddingRight: '16px',
  },
  '&:hover .button-text': {
    opacity: 1,
    width: 'auto',
  },
};

const textStyles: SxProps = {
  whiteSpace: 'nowrap',
  fontSize: '14px',
  fontWeight: 500,
  opacity: 0,
  width: 0,
  transition: 'all 0.5s ease-in-out',
};

const iconStyles: SxProps = {
  flexShrink: 0,
  width: 24,
  height: 24,
};

interface Props {
  icon: ReactNode;
  labelKey: string;
  onClick: () => void;
}

export const QcsFloatingPillButton: FC<Props> = ({ icon, labelKey, onClick }) => {
  const { t } = useTranslation();

  return (
    <Box onClick={onClick} sx={buttonStyles}>
      <Box sx={iconStyles}>{icon}</Box>
      <Box className="button-text" sx={textStyles}>
        {t(labelKey)}
      </Box>
    </Box>
  );
};
